module.exports = __webpack_public_path__ + "static/media/Welder-orange.0dd35658.png";